// extracted by css-extract-rspack-plugin
export default {"base":"UFoqaX1DNID4eRNY xsKXVjVS8cqi4h6y","validInput":"tR6bpdIXc2Qerfxq","validIcon":"LrKxa9DBSZ0qbzPG","_default":"EdXWhJ2Kz_0qEg62","minimal":"_YK5UOo0Oh8sMDnC"};